import { BottomSheetDialog } from '@medely/web-components';
import React from 'react';
import { Button } from '@medely/ui-kit';
import useDevice from '@mp/hooks/useDevice.web';
import { CompensationModalProps } from './types';
import { CompensationModalInfo } from './CompensationModalInfo';
import { W2CompensationModalInfo } from './W2CompensationModalInfo';

export const CompensationModal = ({ open, onClose, isW2 }: CompensationModalProps) => {
  const isDesktop = useDevice() === 'desktop';

  return (
    <BottomSheetDialog
      open={open}
      onClose={onClose}
      title="Compensation details"
      content={isW2 ? <W2CompensationModalInfo /> : <CompensationModalInfo />}
      actions={
        <Button
          variant="outlined"
          onClick={onClose}
          testId="compensation-modal-close-button"
          fullWidth
        >
          Close
        </Button>
      }
      isDesktop={isDesktop}
    />
  );
};
